export enum MilitaryObligations {
Yes,
No,
NotRequired,
}
